export class SubscriptionFeedbackDto {
  prepareFeedbackData({ highlightId, isInterested, offerId }) {
    return {
      interested: isInterested === true,
      highlight_id: highlightId,
      offer_id: offerId,
    };
  }
}
